import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import moment_ from 'moment';
const moment = moment_;
declare var $: any;

@Component({
    selector: 'common-date-range-calendar',
    templateUrl: './date-range-calendar.component.html',
    styleUrls: ['./date-range-calendar.component.scss']
})
export class DateRangeCalendarComponent implements OnInit {
    /** for custom fixed range, with a defined start and end */
    @Input() dateStart = moment().format();
    @Input() dateEnd = moment().add(3, 'weeks').format();
    @Output() onUpdateFixedDates = new EventEmitter<{ start: string; end: string }>();
    public dateFormat = 'MMM d';

    constructor() {}

    ngOnInit(): void {
        this.dateFormat = window.innerWidth > 350 ? 'mediumDate' : 'MMM d';
    }

    ngAfterViewInit() {
        this.initCalendar();
    }

    initCalendar() {
        $('#dateStart').calendar({
            type: 'date',
            minDate: new Date(),
            formatInput: false,
            on: 'click',
            onChange: (date) => {
                if (!date) return;
                this.dateStart = moment(date).format();
                this.onUpdateFixedDates.emit({ start: this.dateStart, end: this.dateEnd });
            }
        });

        $('#dateEnd').calendar({
            type: 'date',
            minDate: new Date(),
            formatInput: false,
            on: 'click',
            popupOptions: {
                position: 'bottom right',
                lastResort: 'bottom right',
                prefer: 'opposite'
            },
            disableMonth: false,
            onChange: (date) => {
                if (!date) return;

                if (moment(date).isBefore(moment(this.dateStart))) {
                    $('body').toast({
                        class: 'error',
                        message: 'Please choose an end date after the start date'
                    });
                }

                this.dateEnd = moment(date).format();
                this.onUpdateFixedDates.emit({ start: this.dateStart, end: this.dateEnd });
            }
        });
    }
}
